module.exports = __webpack_public_path__ + "4411d5b2.png";